<template>
    <div class=" col-md-12 mb-5" >
        <h4 class="left-aligned"> <b> Have access to all your orders </b> </h4>
        <div v-for="(item,i) in temporders" :key="i" class="row mt-4" >
            <div class="col-md-12">
                <b-card  class="col-md-12" style="box-shadow: 0px 3px 6px #00000029;">
                    <div class="row" >
                        <div class="col-md-6 left-aligned" @click="returnItem(item,i)">
                            <span style="font-size: 10px;">Ad Id {{item.id}}</span>
                        </div>
                        <div class="col-md-6 right-aligned" >
                            <span style="font-size: 10px;">{{item.created_at.split('T')[0]}}</span>
                            <span class="ml-1 text-danger fa fa-trash" v-if="loggedUser.id==21" @click="removeOrder(item.id)"></span>

                        </div>
                    </div>
                     <div class="row" @click="returnItem(item,i)">
                        <div class="col-md-4 left-aligned" >
                            <span class="bolds"> {{item.sadqa_aqiqa=='Ijtimai' ? 'Ijtmai Order':'Sadqah Order'}}  {{i+1}}</span>
                        </div>
                        <div class="col-md-4" >
                            <span class="bolds">RS {{item.total_price}}</span>
                        </div>
                        <div class="col-md-4 right-aligned" >
                            <span :class="item.order_delivered==true ? `text-success`:`text-danger`">{{item.order_delivered==true ? `COMPLETED`:`IN PROCESS`}}</span>
                        </div>
                    </div>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import PostCard from '../components/PostCard.vue'
import {RepositoryFactory} from '../Repository/RepositoryFactory'
const OrderRepository = RepositoryFactory.get('order_repository')
export default {
    components:{
        PostCard
    },
    data(){
        return {
            temp:''
        }
    },
    created(){
        if(this.loggedUser.id==21){
            this.temporders=this.admin_orders
        }
        else{
            this.temporders=this.user_resources[3]

        }
    },
    methods:{
        returnItem(item,i) {
            // console.log(item)
            if(item.sadqa_aqiqa=='Ijtimai') {
                console.log("yeh")
                let obj={item:{...item,no:i},id:12}
                this.$emit('return-order',obj)                

            }
            else {
                console.log("yeh")

                let obj={item:{...item,no:i},id:7}
                this.$emit('return-order',obj)
            }

        },
        async removeOrder(id){
         let resp =await OrderRepository.delete_order({sadqa_order_id:id})
         var {data}= await OrderRepository.get_admin_sadqa_orders()
         this.$store.commit("setAdminResources",data[0])


        }
    },
    computed:{
        ...mapGetters(['posts','loggedUser','user_resources','admin_orders'])
    },
    mounted(){
    }

}
</script>

<style>

</style>